// extracted by mini-css-extract-plugin
export default {"BetaLabel":"ArrayField-module__BetaLabel--iDtr7"};